import React, { useEffect, useMemo, useRef, useState } from "react";
import { useRouteMatch, NavLink } from "react-router-dom";
import AnimatedPages from "../Animation/AnimatedPages";
import light from "./../../assets/our work/0.png";
import { categoriesProjects } from "./categoriesProjects";

const DefaultView = () => {
  const { url } = useRouteMatch();
  const [activeIdx, setActiveIdx] = useState(0);
  const tabs = useMemo(() => categoriesProjects.map((c) => c.name), []);
  const containerRef = useRef(null);
  const panelRefs = useRef([]);
  const roRef = useRef(null); // ResizeObserver

  const headerRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  const updateOverflow = () => {
    const el = headerRef.current;
    if (!el) return;
    // لو المحتوى أعرض من الكونتينر => في Overflow
    if (el.scrollWidth > el.clientWidth) {
      el.classList.add("is-overflowing");
    } else {
      el.classList.remove("is-overflowing");
    }
  };
  // تحديث حالة الأسهم حسب الاسكرول/الريسايز
  const updateArrows = () => {
    const el = headerRef.current;
    if (!el) return;
    const hasOverflow = el.scrollWidth > el.clientWidth;
    const sl = el.scrollLeft;
    const max = el.scrollWidth - el.clientWidth;

    // لو محتوى التابس أكبر من العرض -> في Overflow
    setShowLeft(hasOverflow && sl > 2);
    setShowRight(hasOverflow && sl < max - 2);
  };
  useEffect(() => {
    updateOverflow();
    // راقب الريسايز وأي تغيّر في حجم شريط التابس
    window.addEventListener("resize", updateOverflow);
    const ro = new ResizeObserver(updateOverflow);
    if (headerRef.current) ro.observe(headerRef.current);
    return () => {
      window.removeEventListener("resize", updateOverflow);
      ro.disconnect();
    };
  }, [tabs.length]);

  const setContainerHeight = () => {
    const panel = panelRefs.current[activeIdx];
    const container = containerRef.current;
    if (panel && container) {
      container.style.height = panel.scrollHeight + "px";
    }
  };

  useEffect(() => {
    const onResize = () => setContainerHeight();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    updateArrows();
    const el = headerRef.current;
    if (!el) return;

    const onScroll = () => updateArrows();
    el.addEventListener("scroll", onScroll, { passive: true });

    const ro = new ResizeObserver(updateArrows);
    ro.observe(el);

    window.addEventListener("resize", updateArrows);

    return () => {
      el.removeEventListener("scroll", onScroll);
      ro.disconnect();
      window.removeEventListener("resize", updateArrows);
    };
  }, []);
  const scrollStep = (dir) => {
    const el = headerRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.8); // تمرير حوالي 80% من العرض
    el.scrollBy({
      left: dir === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <AnimatedPages>
      <div className="DefaultView">
        <div className="col-12 d-flex align-items-end justify-content-center">
          <div className="img-wrapper">
            <img src={light} alt="light" className="img-fluid" />
          </div>
          <div>
            <h1 className="">Our Work</h1>
            <h6>A sample of our best work</h6>
          </div>
        </div>

        <div className="proj-tabs mt-5">
          <div
            className={`tabs-header-wrap ${showLeft ? "show-left" : ""} ${
              showRight ? "show-right" : ""
            }`}
          >
            <button
              type="button"
              aria-label="Scroll left"
              className="tabs-arrow left"
              hidden={!showLeft}
              onClick={() => scrollStep("left")}
            >
              ‹
            </button>

            <div
              className="tabs-header no-wrap"
              role="tablist"
              aria-label="Project categories"
              ref={headerRef}
            >
              {tabs.map((label, i) => (
                <button
                  key={label}
                  role="tab"
                  aria-selected={i === activeIdx}
                  aria-controls={`panel-${i}`}
                  id={`tab-${i}`}
                  className={`tab-btn ${i === activeIdx ? "active" : ""}`}
                  onClick={() => setActiveIdx(i)}
                >
                  {label}
                </button>
              ))}
            </div>

            <button
              type="button"
              aria-label="Scroll right"
              className="tabs-arrow right"
              hidden={!showRight}
              onClick={() => scrollStep("right")}
            >
              ›
            </button>
          </div>

          <div className="tabs-panels" ref={containerRef}>
            {categoriesProjects.map((cat, i) => (
              <div
                key={cat.name}
                role="tabpanel"
                id={`panel-${i}`}
                aria-labelledby={`tab-${i}`}
                className={`tab-panel ${i === activeIdx ? "active" : "hidden"}`}
              >
                <div className="col-12 row m-0 mt-4 align-items-stretch">
                  {cat.projects.map((project, index) => (
                    <div className="col-lg-4 col-md-6 col-12 mt-4" key={index}>
                      <div
                        className={`card text-center shadow  pb-3 pt-4  h-100 `}
                      >
                        <NavLink
                          className="top-card-link"
                          to={`${url}/${project.linkTo}`}
                        >
                          <div
                            style={{ minHeight: "200px" }}
                            className="d-flex"
                          >
                            <img
                              className={`card-img-top align-self-center${
                                project.Graveler ? "" : ""
                              } `}
                              src={project.Image}
                              alt={project.id}
                              style={{
                                padding: project?.withPadding ? "25px" : "",
                                paddingLeft: project?.withBigPadding
                                  ? "30px"
                                  : "",
                                paddingRight: project?.withBigPadding
                                  ? "30px"
                                  : "",
                              }}
                            />
                          </div>

                          <div className="card-body px-4 pb-0">
                            <h5 className="card-title">{project.name}</h5>
                            <p
                              style={{ minHeight: "36px" }}
                              className="card-text "
                            >
                              {project.subTitle ? project.subTitle : ""}
                            </p>
                            <p
                              style={{ minHeight: "36px" }}
                              className="card-text mt-3"
                            >
                              {project.text ? project.text : ""}
                            </p>
                            <p className="icon">
                              <span>
                                {project.icon1 ? (
                                  <i className={project.icon1}></i>
                                ) : null}
                              </span>
                              {project.icon2 ? (
                                <span className="ms-1">
                                  <i className={project.icon2}></i>
                                </span>
                              ) : (
                                ""
                              )}
                              {project.image ? (
                                <img
                                  className="ms-1"
                                  src={project.image}
                                  style={{
                                    width: "40px",
                                    marginBottom: "5px",
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </p>
                            {/* <p className="type">{project.type}</p> */}
                            <div className="card-link-wrap ">
                              <div className="card-link d-flex align-items-center justify-content-center">
                                See More{" "}
                                <div className="ms-1 text-white">
                                  <i className="fas fa-chevron-right"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AnimatedPages>
  );
};

export default DefaultView;
